import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

const MINIMUM_AGE_REQUIRED = 18;

function calcAge(date) {
   var dBirth = date;
   var dToday = new Date();
   var diff = dToday.getTime() - dBirth.getTime();
   return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
 }
 
export function ValidateAge(control: AbstractControl) {

    if (control.value !== null && control.value !== undefined && control.value !== '') {

        let age = calcAge(new Date(control.value));

        if (age <= 0) {
            return { dateError: true };
        }

        if (age < MINIMUM_AGE_REQUIRED) {
            return { minimumAgeRequired: true };
        }
    }
    return null;
}

export function ValidateReCorreo(control: AbstractControl) {

    if (control.get('reCorreo').value !== null && control.get('reCorreo').value !== undefined && control.get('reCorreo').value !== '') {
        
        if ( control.get('correo').value !== control.get('reCorreo').value ) {       

            control.get('reCorreo').setErrors({ mismatch: true });

            return {mismatch: true};

        }

    }
    return null;
  }